module.exports = __webpack_public_path__ + "img/il-page-not-found.9f289d6.svg";